import { render, staticRenderFns } from "./ConfirmationModal.vue?vue&type=template&id=1936bb80&scoped=true&"
import script from "./ConfirmationModal.vue?vue&type=script&lang=ts&"
export * from "./ConfirmationModal.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmationModal.vue?vue&type=style&index=0&id=1936bb80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1936bb80",
  null
  
)

export default component.exports